import { Classes } from 'mbc/dist/mbc-core';

function LegendMixin() {}
// do nothing: don't adjust legend width by text max width.
LegendMixin.prototype.adjustLegendWidth = function() {};

LegendMixin.prototype.drawRightLegend = function() {
  const container = this.get('selection').selectAll(`.${Classes.LEGEND}`);
  const sortedLegendData = this.sortLegendData();
  const innerContainer = container.append('div').classed('mbc-chart-legend-right-inner-div', true);
  const legend = innerContainer.selectAll(`.${Classes.LEGEND_ITEM}`).data(sortedLegendData);
  const legendValuesFormat = this.get('legendValuesFormat');
  const dottedLines = this.get('dottedLines');
  const itemEnter = legend
    .enter()
    .append('div')
    .classed(Classes.LEGEND_ITEM, true);

  itemEnter
    .append('p')
    .attr('class', `${Classes.LEGEND_ITEM}__label--right`)
    .text(function(d) {
      return d.displayName;
    })
    .attr('title', function(d) {
      return d.displayName;
    })
    .style(
      'border-top',
      function(d) {
        const color = this.color(d.index);
        const lineIsDotted = dottedLines.indexOf(d.displayName) > -1;
        const style = lineIsDotted ? `2px dotted ${color}` : `2px solid ${color}`;
        return style;
      }.bind(this)
    );

  // Update
  legend
    .selectAll('p')
    .filter(`.${Classes.LEGEND_ITEM}__label--right`)
    .data(function(d) {
      return [d];
    })
    .text(function(d) {
      return d.displayName;
    })
    .style(
      'border-top',
      function(d) {
        const color = this.color(d.index);
        const lineIsDotted = dottedLines.indexOf(d.displayName) > -1;
        const style = lineIsDotted ? `2px dotted ${color}` : `2px solid ${color}`;
        return style;
      }.bind(this)
    );

  if (this.get('showLegendValues')) {
    itemEnter
      .append('p')
      .attr('class', `${Classes.LEGEND_ITEM}__value--right`)
      .text(function(d) {
        return legendValuesFormat(d.value);
      });

    // Update
    legend
      .selectAll('p')
      .filter(`.${Classes.LEGEND_ITEM}__value--right`)
      .data(function(d) {
        return [d];
      })
      .attr('class', `${Classes.LEGEND_ITEM}__value--right`)
      .text(function(d) {
        const value = legendValuesFormat(d.value);
        return value;
      });
  }

  // Exit
  legend.exit().remove();
};

LegendMixin.prototype.sortLegendData = function() {
  const dataManager = this.get('data');
  let sortedArr = [];

  const self = this;
  const addLegendSet = function(group) {
    group.forEach(function(dataset) {
      const value = self.getValidEndValue(dataset.series);
      const { displayName } = dataset;
      const { index } = dataset;
      sortedArr.push({ value, displayName, index });
    });
  };

  const y1DomainDataset = this.get('y1DomainDataset');
  let groups = [y1DomainDataset];
  if (this.get('y2')) {
    const y2DomainDataset = this.get('y2DomainDataset');
    groups = groups.concat(y2DomainDataset);
  }

  groups.forEach(function(name) {
    addLegendSet(dataManager.get(name));
  });

  // sort legend items by the end value of series line
  sortedArr = this.sortDataByEndValue(sortedArr);

  return sortedArr;
};

export default LegendMixin;
